module.exports = __webpack_public_path__ + "static/sport/swiper-1.ff35932.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/invite/swiper-1.png
// module id = XWQZ
// module chunks = 0